import { render, staticRenderFns } from "./Robots.vue?vue&type=template&id=60e3e84c&scoped=true&lang=pug&"
import script from "./Robots.vue?vue&type=script&lang=js&"
export * from "./Robots.vue?vue&type=script&lang=js&"
import style0 from "./Robots.vue?vue&type=style&index=0&id=60e3e84c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e3e84c",
  null
  
)

export default component.exports